const body = document.body;
const announcement = document.querySelector(".announcement");
const announcementClose = document.querySelector(".announcement__close");
const navToggle = document.querySelector(".nav-toggle");
const navMenu = document.querySelector(".nav-menu");
const cartButton = document.querySelector(".cart-button");
const cartDrawer = document.querySelector(".cart-drawer");
const cartClose = document.querySelector(".cart-close");
const cartItems = document.querySelector(".cart-items");
const cartCount = document.querySelector(".cart-count");
const cartTotal = document.querySelector(".cart-total strong");
const cartMicrocopy = document.querySelector("[data-cart-microcopy]");
const filters = document.querySelectorAll(".filter");
const productCards = document.querySelectorAll(".product-card");
const stepperGroups = document.querySelectorAll("[data-stepper]");

function syncMenuOffset() {
  const root = document.documentElement;
  const header = document.querySelector(".site-header");
  if (!header) return;
  const headerHeight = Math.round(header.getBoundingClientRect().height);
  const announcementHeight =
    announcement?.isConnected ? Math.round(announcement.getBoundingClientRect().height) : 0;
  const announcementOffset = Math.max(announcementHeight - Math.round(window.scrollY), 0);

  root.style.setProperty("--header-height", `${headerHeight + (document.querySelector(".batch-announcement")?.getBoundingClientRect().height || 0)}px`);
  root.style.setProperty("--announcement-offset", `${announcementOffset}px`);
  root.style.setProperty("--menu-top", `${announcementOffset + headerHeight}px`);
}

function formatMoney(cents) {
  return new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: window.Shopify?.currency?.active || "USD",
  }).format(cents / 100);
}

function escapeHTML(value) {
  return String(value)
    .replace(/&/g, "&amp;")
    .replace(/</g, "&lt;")
    .replace(/>/g, "&gt;")
    .replace(/"/g, "&quot;")
    .replace(/'/g, "&#039;");
}

function openCart() {
  if (!cartDrawer || !cartButton || !cartClose) return;
  cartDrawer.classList.add("is-open");
  cartDrawer.setAttribute("aria-hidden", "false");
  cartButton.setAttribute("aria-expanded", "true");
  body.classList.add("cart-open");
  cartClose.focus();
}

function closeCart() {
  if (!cartDrawer || !cartButton) return;
  cartDrawer.classList.remove("is-open");
  cartDrawer.setAttribute("aria-hidden", "true");
  cartButton.setAttribute("aria-expanded", "false");
  body.classList.remove("cart-open");
  cartButton.focus();
}

async function getCart() {
  const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart.js`, {
    headers: { Accept: "application/json" },
  });
  if (!response.ok) throw new Error("Could not load cart");
  return response.json();
}

function renderCart(cart) {
  if (!cartItems || !cartCount || !cartTotal) return;

  cartCount.textContent = cart.item_count;
  cartTotal.textContent = formatMoney(cart.total_price);

  if (cartMicrocopy) {
    const hasSubscription = cart.items.some((item) => item.selling_plan_allocation);
    cartMicrocopy.textContent = hasSubscription
      ? "Shipping included. Secure checkout."
      : "Free shipping at $70. Secure checkout. Small batches ship while fresh.";
  }

  if (!cart.items.length) {
    cartItems.innerHTML = '<p class="empty-cart">Your cart is ready for bold flavor.</p>';
    return;
  }

  cartItems.innerHTML = cart.items
    .map(
      (item) => `
        <article class="cart-line">
          ${item.image ? `<img src="${item.image}" alt="">` : ""}
          <div class="cart-line__details">
            <strong>${escapeHTML(item.product_title)}</strong>
            ${item.variant_title && item.variant_title !== "Default Title" ? `<span class="cart-line__meta">${escapeHTML(item.variant_title)}</span>` : ""}
            ${item.selling_plan_allocation?.selling_plan?.name ? `<span class="cart-line__subscription">${escapeHTML(item.selling_plan_allocation.selling_plan.name)}</span>` : ""}
            <div class="cart-line__controls" aria-label="Quantity for ${escapeHTML(item.product_title)}">
              <button type="button" data-cart-action="decrease" data-cart-key="${item.key}" aria-label="Decrease ${escapeHTML(item.product_title)} quantity">-</button>
              <span>${item.quantity}</span>
              <button type="button" data-cart-action="increase" data-cart-key="${item.key}" aria-label="Increase ${escapeHTML(item.product_title)} quantity">+</button>
              <button type="button" class="cart-line__remove" data-cart-action="remove" data-cart-key="${item.key}">Remove</button>
            </div>
          </div>
          <b>${formatMoney(item.final_line_price)}</b>
        </article>
      `,
    )
    .join("");
}

async function changeCartItem(key, quantity) {
  if (!cartDrawer) return;
  cartDrawer.setAttribute("aria-busy", "true");

  const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/change.js`, {
    method: "POST",
    headers: {
      Accept: "application/json",
      "Content-Type": "application/json",
    },
    body: JSON.stringify({ id: key, quantity }),
  });

  cartDrawer.removeAttribute("aria-busy");
  if (!response.ok) throw new Error("Could not update cart");
  renderCart(await response.json());
}

async function addFormToCart(form) {
  const formData = new FormData(form);
  const button = form.querySelector("button[type='submit']");
  button?.setAttribute("aria-busy", "true");

  const response = await fetch(`${window.Shopify?.routes?.root || "/"}cart/add.js`, {
    method: "POST",
    headers: { Accept: "application/json" },
    body: formData,
  });

  button?.removeAttribute("aria-busy");
  if (!response.ok) {
    form.submit();
    return;
  }

  renderCart(await getCart());
  openCart();
}

announcementClose?.addEventListener("click", () => {
  announcement?.remove();
  syncMenuOffset();
});

navToggle?.addEventListener("click", () => {
  syncMenuOffset();
  const isOpen = navMenu.classList.toggle("is-open");
  navToggle.setAttribute("aria-expanded", String(isOpen));
  body.classList.toggle("menu-open", isOpen);
});

navMenu?.addEventListener("click", (event) => {
  if (event.target instanceof HTMLAnchorElement) {
    navMenu.classList.remove("is-open");
    navToggle.setAttribute("aria-expanded", "false");
    body.classList.remove("menu-open");
  }
});

filters.forEach((filter) => {
  filter.addEventListener("click", () => {
    const category = filter.dataset.filter;

    filters.forEach((button) => button.classList.remove("is-active"));
    filter.classList.add("is-active");

    productCards.forEach((card) => {
      const shouldShow = category === "all" || card.dataset.category === category;
      card.classList.toggle("is-hidden", !shouldShow);
    });
  });
});

document.querySelector(".gallery__thumbs")?.addEventListener("click", (event) => {
  const thumb = event.target.closest(".thumb");
  const activeGalleryMain = document.querySelector(".gallery__main");
  if (!thumb || !activeGalleryMain) return;

  const image = thumb.dataset.image;
  if (!image) return;

  document.querySelectorAll(".thumb").forEach((button) => button.classList.remove("is-active"));
  thumb.classList.add("is-active");
  activeGalleryMain.src = image;
});

stepperGroups.forEach((stepper) => {
  stepper.addEventListener("click", (event) => {
    const button = event.target.closest("[data-step]");
    const input = stepper.querySelector("input");
    if (!button || !input) return;

    const current = Number(input.value) || 1;
    const next = button.dataset.step === "up" ? current + 1 : Math.max(1, current - 1);
    input.value = String(next);
  });
});

document.querySelectorAll("[data-add-to-cart-form]").forEach((form) => {
  form.addEventListener("submit", (event) => {
    event.preventDefault();
    addFormToCart(form).catch(() => form.submit());
  });
});

const utmNames = ["utm_source", "utm_medium", "utm_campaign", "utm_content", "utm_term", "fbclid"];
const storedUtmKey = "bcscLandingUtm";
const incomingUtm = Object.fromEntries(
  utmNames
    .map((name) => [name, new URLSearchParams(window.location.search).get(name)])
    .filter(([, value]) => value),
);

if (Object.keys(incomingUtm).length) {
  sessionStorage.setItem(storedUtmKey, JSON.stringify(incomingUtm));
}

let preservedUtm = incomingUtm;
if (!Object.keys(preservedUtm).length) {
  try {
    preservedUtm = JSON.parse(sessionStorage.getItem(storedUtmKey) || "{}");
  } catch {
    preservedUtm = {};
  }
}

document.querySelectorAll("form[data-preserve-utm]").forEach((form) => {
  Object.entries(preservedUtm).forEach(([name, value]) => {
    const input = document.createElement("input");
    input.type = "hidden";
    input.name = `attributes[${name}]`;
    input.value = value;
    form.append(input);
  });

  form.querySelectorAll("[data-variant-option]").forEach((option) => {
    option.addEventListener("change", () => {
      const price = form.querySelector("[data-landing-price]");
      if (price) price.textContent = option.dataset.price || "";
    });
  });
});

document.querySelectorAll("[data-landing-page]").forEach((landing) => {
  const primaryForm = landing.querySelector(".landing-page__hero form[data-preserve-utm]");
  const stickyForm = landing.querySelector(".landing-purchase--sticky");
  if (!primaryForm || !stickyForm) return;
  const syncStickyVariant = () => {
    const selected = primaryForm.querySelector("[data-variant-option]:checked");
    const stickyVariant = stickyForm.querySelector("[data-sticky-variant]");
    if (selected && stickyVariant) stickyVariant.value = selected.value;
  };
  primaryForm.querySelectorAll("[data-variant-option]").forEach((option) => option.addEventListener("change", syncStickyVariant));
  syncStickyVariant();

  const stickyContainer = landing.querySelector("[data-landing-sticky]");
  const closingForm = landing.querySelector(".landing-purchase--final");
  const footer = document.querySelector(".site-footer");
  if (!stickyContainer || !window.matchMedia("(max-width: 759px)").matches) return;

  const updateStickyVisibility = () => {
    const isVisibleInViewport = (element) => {
      if (!element) return false;
      const rect = element.getBoundingClientRect();
      return rect.bottom > 0 && rect.top < window.innerHeight;
    };
    const shouldShow = !isVisibleInViewport(primaryForm) && !isVisibleInViewport(closingForm) && !isVisibleInViewport(footer);
    stickyContainer.classList.toggle("is-visible", shouldShow);
    stickyContainer.setAttribute("aria-hidden", shouldShow ? "false" : "true");
  };
  window.addEventListener("scroll", updateStickyVisibility, { passive: true });
  window.addEventListener("resize", updateStickyVisibility);
  updateStickyVisibility();
});

document.querySelectorAll("[data-video-embed]").forEach((video) => {
  video.querySelector(".video-thumb")?.addEventListener("click", () => {
    const id = video.dataset.videoEmbed?.trim();
    if (!id) return;
    video.innerHTML = `
      <iframe
        src="https://www.youtube.com/embed/${encodeURIComponent(id)}?autoplay=1&rel=0"
        title="Burns Canyon story video"
        allow="accelerometer; autoplay; clipboard-write; encrypted-media; gyroscope; picture-in-picture; web-share"
        allowfullscreen>
      </iframe>
    `;
  });
});

cartButton?.addEventListener("click", (event) => {
  if (!cartDrawer) return;
  event.preventDefault();
  getCart().then(renderCart).finally(openCart);
});

cartClose?.addEventListener("click", closeCart);

cartDrawer?.addEventListener("click", (event) => {
  if (event.target === cartDrawer) closeCart();
});

cartItems?.addEventListener("click", (event) => {
  const button = event.target.closest("[data-cart-action]");
  if (!button) return;

  const line = button.closest(".cart-line");
  const quantity = Number(line?.querySelector(".cart-line__controls span")?.textContent) || 1;
  const key = button.dataset.cartKey;
  if (!key) return;

  const nextQuantity =
    button.dataset.cartAction === "increase"
      ? quantity + 1
      : button.dataset.cartAction === "decrease"
        ? Math.max(0, quantity - 1)
        : 0;

  changeCartItem(key, nextQuantity).catch(() => getCart().then(renderCart));
});

document.addEventListener("keydown", (event) => {
  if (event.key === "Escape" && cartDrawer?.classList.contains("is-open")) {
    closeCart();
  }
});

window.addEventListener("resize", syncMenuOffset);
window.addEventListener("scroll", syncMenuOffset, { passive: true });
syncMenuOffset();
